export default "__VITE_PUBLIC_ASSET__1f5e900b__"